








































import Vue from 'vue';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import { OnboardingSuggestedProductPathKey } from '~/components/partials/connections/types';
import { IS_SELECTED_JOBS_PRODUCT } from '~/components/partials/jobs/constants';
import TrustPilotBadge from '@/components/global/Badges/TrustPilotBadge.vue';

export default Vue.extend({
  name: 'MainPageBanner',
  components: {
    BravadoButtonV3,
    TrustPilotBadge,
    IntroCardsAnimation: () => import('@/components/partials/landings/ui/IntroCardsAnimation.vue'),
  },
  methods: {
    emitSignUpClick() {
      this.$cookies.set(IS_SELECTED_JOBS_PRODUCT, OnboardingSuggestedProductPathKey.JobsProfile);
      this.$emit('sign-up-click', 'position3');
    },
  },
});
